// extracted by mini-css-extract-plugin
module.exports = {"list-photos":"list-photos","listPhotos":"list-photos"};